import React from "react";
import { CheckCircle, Sparkles, Phone, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function HeroTreppenhausReinigung() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="34271" id="hero-intro" className="relative w-full overflow-hidden bg-background text-foreground py-20 lg:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/10 to-background/95 z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_hero_israel.png" alt="מטפל סיעודי מקצועי בישראל" className="h-full w-full object-cover opacity-30" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={ref} className={cn("mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          {}
          <div className="mb-6 inline-flex items-center rounded-full border border-primary/20 bg-accent px-3 py-1 text-sm font-default font-medium text-primary backdrop-blur-sm">
            <Sparkles className="ml-2 h-3.5 w-3.5" />
            <span>מטפל סיעודי תוך שעות, לא ימים</span>
          </div>

          {}
          <h1 className="mb-6 text-4xl font-default font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-7xl">
            מטפל סיעודי תוך <span className="text-primary">5 שעות</span> – בכל הארץ
          </h1>

          {}
          <p className="mb-8 max-w-2xl font-default text-lg text-muted-foreground md:text-xl">
            מטפלים ישראלים בלבד | שירות לבית ולבית חולים | זמינות מיידית
          </p>

          {}
          <div className="flex flex-col gap-4 sm:flex-row sm:justify-center">
            <Button asChild size="lg" className="bg-[#0bb5d4] text-white shadow-lg hover:bg-[#0bb5d4]/90 font-default border-none">
              <Link to="#">
                התקשר עכשיו
                <Phone className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-primary/20 bg-background/50 text-primary hover:bg-primary/5 hover:text-primary font-default">
              <Link to="https://wa.me/972000000000" newTab>
                וואטסאפ מיידי
                <MessageCircle className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>

          {}
          <div className="mt-12 flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-default font-medium text-muted-foreground">
            {[{
            label: "זמינות מיידית 24/7",
            path: "/NursingCareNowPage"
          }, {
            label: "צוות מטפלים מוסמך",
            path: ""
          }, {
            label: "ליווי אישי צמוד",
            path: "/ContactPage"
          }, {
            label: "התאמה מהירה למשפחה",
            path: ""
          }].map((item, i) => <div key={i} data-index={i} className="flex items-center">
                <CheckCircle className="ml-2 h-4 w-4 text-primary" />
                {item.path ? <Link to={item.path} className="hover:text-primary transition-colors">
                    {item.label}
                  </Link> : <span>{item.label}</span>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}